var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataSources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 21,
    viewBox: "0 0 41 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2068 3.92777C23.6173 1.85452 20.9221 0.5 17.8675 0.5C12.9746 0.5 9.00781 3.99688 9.00781 8.30924C9.00781 8.32306 9.00781 8.3507 9.00781 8.36453",
    stroke: "#2D2D2D",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97156 19.9473C3.90729 19.3668 3.02271 18.6342 2.40073 17.7635C1.75111 16.8651 1.37793 15.8423 1.37793 14.7504C1.37793 14.6951 1.37793 14.626 1.37793 14.5707C1.50232 11.3917 4.77806 8.7794 9.00749 8.36475",
    stroke: "#2D2D2D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2061 3.92775C26.0077 3.49928 26.9338 3.25049 27.9151 3.25049C30.8591 3.25049 33.2779 5.46195 33.5958 8.30922",
    stroke: "#2D2D2D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0449 20.4863H33.5411C35.2273 20.4863 36.7477 19.809 37.8396 18.7033C38.9454 17.5976 39.6226 16.0772 39.6226 14.4048C39.6226 11.0599 36.9274 8.33706 33.5826 8.32324",
    stroke: "#2D2D2D",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.37793 14.5845C1.40557 15.7593 1.77876 16.865 2.40073 17.7773C3.03653 18.731 3.92112 19.4773 4.97156 19.9611C5.73175 20.3066 6.57487 20.5001 7.45946 20.5001H13.0711",
    stroke: "#2D2D2D",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0703 14.1558H24.3771",
    stroke: "#2D2D2D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0703 17.2104H24.3771",
    stroke: "#2D2D2D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0703 20.4863H24.3771",
    stroke: "#2D2D2D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSources);
export default __webpack_public_path__ + "static/media/dataSources.a4240ef9b2e6960275c48a5e33c67e92.svg";
export { ForwardRef as ReactComponent };